<svelte:options accessors/>
<script lang="ts">
    import {IFilterCategory, IProductPreview} from "../../interfaces";
    import RadioSelect from "../molecules/RadioSelect.svelte";
    import {createEventDispatcher, onMount} from "svelte";
    import FilterSelect from "../molecules/FilterSelect.svelte";
    import SlideOver from "../layout/SlideOver.svelte";
    import {Cart, getCart} from "../../models/cart";
    import CatalogPage from "./CatalogPage.svelte";

    export let data: Array<IProductPreview> = [];
    export let filters: Array<IFilterCategory>;
    let filtersCmpt;
    export let loading: boolean = true;
    export let showViewMore: boolean = true;
    export let preloadFilters = {}
    let pageCmpt;
    let cart: Cart;
    export let filter = {
        overlay: false,
        active: []
    }

    const dispatch = createEventDispatcher();

    onMount(() => {
        filters = filters.map((category) => {
            category['active'] = false;
            category.options = category.options.map((x) => {
                x['active'] = false;
                return x;
            });
            return category;
        })
        filters.forEach((f) => {
            if (!!preloadFilters[f.slug]) {
                f.options.forEach((option) => {
                    option.active = !!preloadFilters[f.slug].find(i => i === option.value);
                    if (option.active) {
                        (option.children ?? []).forEach((child) => {
                            if (!!preloadFilters[child.slug]) {
                                child.options.forEach((o) => {
                                    o.active = !!preloadFilters[child.slug].find(i => i === o.value);
                                });
                            }
                        });
                    }
                });
            }
        });
        getCart().then((c) => {
            cart = c;
        });
    });

    let order = {
        overlay: false,
        options: [
            {
                label: 'Menor a mayor precio',
                value: 'menor-mayor'
            },
            {
                label: 'Mayor a menor precio',
                value: 'mayor-menor'
            }
        ],
        active: 'vendidos'
    }


    function orderBy() {
        order.overlay = false;
        switch (order.active) {
            case 'menor-mayor':
                data = data.sort((a, b) => b.price - a.price);
                break
            case 'mayor-menor':
                data = data.sort((a, b) => a.price - b.price);
                break
        }
    }

    function filterBy() {
        filter.overlay = false;
        if (pageCmpt) {
            pageCmpt.clear();
        }
        data = [];
        dispatch('filterby', filter.active);
    }

    function clearFilter(slug, value, parent = null) {
        if (parent) {
            const p = filters.find(f => f.slug === parent.slug);
            if (p) {
                p.options.forEach((o) => {
                    if (o.value === parent.value) {
                        (o.children || []).forEach((i) => {
                            i.options.forEach(_ => {
                                if (_.value === value) {
                                    _.active = false
                                }
                            });
                        });
                    }
                })
            }
        } else {
            const find = filters.find(f => f.slug === slug);
            if (find) {
                find.options.forEach((o) => {
                    if (o.value === value) {
                        o.active = false;
                        (o.children || []).forEach((i) => {
                            i.options.forEach(_ => _.active = false);
                        })
                    }
                })
            }
        }

        filters = filters;
        if (filtersCmpt) {
            filtersCmpt.emitFilters();
        }
        filterBy();
    }

    function clear() {
        filters.forEach((category) => {
            category.options.forEach((x) => {
                x.active = false;
            })
        });
        filter.active = [];
        filters = filters;
        filterBy();
        2
    }

    export function addData(items) {
        if (items.length > 0) {
            data.push(...items);
            data = [...data];
        } else {
            /*data = undefined;
            setTimeout(() => {
                data = [];
            }, 50);*/
        }

    }
</script>
<section>
    <div class="grid-2 py-ii border-bottom buttons">
        <div class="box sx-ii py-ii pointer" on:click="{()=> order.overlay = true}">
            <img height="15" src="/static/storefront/pix/icons/ordenar.svg" alt="Ordenar">
            <span>Ordenar</span>
        </div>
        {#if filters?.length > 0}
            <div class="box sx-ii py-ii pointer" on:click="{()=> filter.overlay = true}">
                <img height="15" src="/static/storefront/pix/icons/filtrar.svg" alt="Filtros">
                <span>Filtrar</span>
            </div>
        {/if}
    </div>
    {#if filter.active.length > 0 }
        <div class="container box-l pt-ii  filter-box">
            {#each filters as filt (filt.slug)}
                {#each filt.options as opt (opt.value)}
                    {#if opt.active}
                        <div class="filter-chip my-i mr-ii box-l sx-1">
                            <span>{opt.label}</span>
                            <span class="times pointer"
                                  on:click="{()=>clearFilter(filt.slug, opt.value)}">&times;</span>
                        </div>
                        {#each (opt?.children ?? []) as child}
                            {#each child.options as o}
                                {#if o.active}
                                    <div class="filter-chip my-i mr-ii box-l sx-1"
                                         on:click="{()=>clearFilter(o.slug, o.value, {slug: filt.slug, value: opt.value})}">
                                        <span>{o.label}</span>
                                        <span class="times pointer">
                                        &times;
                                    </span>
                                    </div>
                                {/if}
                            {/each}
                        {/each}
                    {/if}
                {/each}
            {/each}
            <div>
                <div class="line-times">
                    <div class="filter-chip times" on:click={clear}>&times</div>
                </div>
            </div>

        </div>
    {/if}


    <div class="container py-15">
        {#if data}
            <CatalogPage {data}
                         {cart}
                         {showViewMore}
                         {loading}
                         bind:this={pageCmpt}
                         on:next/>
        {/if}
    </div>


    <SlideOver bind:open={order.overlay}>
        <h2 class="mb-2">Todo para tu Nissan</h2>
        <RadioSelect options="{order.options}" bind:active="{order.active}"/>
        <div slot="actions">
            <div class="box-r sx-ii">
                <div class="btn" on:click={()=> order.overlay = false}>CANCELAR</div>
                <div class="btn solid accent" on:click={orderBy}>ORDERNAR</div>
            </div>
        </div>
    </SlideOver>

    <SlideOver bind:open={filter.overlay}
               maxWidth="300px">
        <h2 class="mb-1">Filtros</h2>
        <FilterSelect bind:this={filtersCmpt}
                      bind:filters="{filters}"
                      on:filtered={(event)=>filter.active = event.detail}/>
        <div slot="actions">
            <div class="box-r sx-ii">
                <div class="btn" on:click={()=> filter.overlay = false}>CANCELAR</div>
                <div class="btn solid accent" on:click={filterBy}>FILTRAR</div>
            </div>
        </div>
    </SlideOver>

</section>
<style>
    .buttons span {
        font-size: 15px;
    }

    .buttons > *:first-child {
        border-right: 1px solid var(--bg-gray);
    }

    .filter-chip {
        background: var(--bg-gray);
        font-size: 12px;
        padding: .25rem .5rem;
        border-radius: 2rem;
        min-width: max-content;
    }

    .filter-chip .times {
        font-family: sans-serif;
        font-size: 16px;
        line-height: 12px;
        position: relative;
        top: -1px;
    }

    .filter-chip.times {
        font-family: sans-serif;
        font-size: 16px;
        line-height: 12px;
        padding: 0;
        display: flex;
        text-align: center;
        justify-content: center;
        align-items: center;
        width: 20px;
        height: 20px;
    }

    .filter-box {
        flex-wrap: wrap;
    }

    .line-times {
        height: 20px;
        border-left: 1px solid var(--bg-gray);
        padding-left: 10px;
    }

</style>
